"use client"

import { keyframes } from "@emotion/react"
import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import { useLocale } from "next-intl"
import { useEffect, useRef } from "react"
import { sharedColors } from "ui/theme/colors"

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const StyledSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid ${sharedColors.brandDark};
  border-top: 4px solid transparent;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`
const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 32px;
  padding-bottom: 226px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 184px 0;
  }
`

export default function Loading() {
  const layoutRef = useRef<HTMLDivElement>(null)
  const locale = useLocale()
  useEffect(() => {
    if (layoutRef.current) {
      layoutRef.current.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }, [])

  return (
    <StyledLayout ref={layoutRef}>
      <StyledSpinner />
      <Typography variant="body1">
        {locale === "he" ? "עוד כמה רגעים..." : "A few more moments..."}
      </Typography>
    </StyledLayout>
  )
}
